import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Layout Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import SolutionsPage from "./pages/SolutionsPage";
import HRPage from "./pages/solutions/HRPage";
import ProjectPage from "./pages/solutions/ProjectPage";
import SalesPage from "./pages/solutions/SalesPage";
import MarketingPage from "./pages/solutions/MarketingPage";
import FinancePage from "./pages/solutions/FinancePage";
import CustomITPage from "./pages/solutions/CustomITPage";
import ContactPage from "./pages/ContactPage";
import BookDemoPage from "./pages/BookDemoPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/solutions/hr" element={<HRPage />} />
            <Route path="/solutions/project" element={<ProjectPage />} />
            <Route path="/solutions/sales" element={<SalesPage />} />
            <Route path="/solutions/marketing" element={<MarketingPage />} />
            <Route path="/solutions/finance" element={<FinancePage />} />
            <Route path="/solutions/custom-it" element={<CustomITPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/book-demo" element={<BookDemoPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster 
          position="top-right" 
          richColors 
          toastOptions={{
            style: {
              background: '#1e293b',
              border: '1px solid #334155',
              color: '#f8fafc',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
